import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { CaseStudies } from '../components/CaseStudies';
import { About } from '../components/About';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Portfolio() {
  return <div className="min-h-screen bg-bg text-text font-sans selection:bg-accent/20 selection:text-text" data-id="element-77">
      <Navigation data-id="element-78" />
      <main data-id="element-79">
        <Hero data-id="element-80" />
        <CaseStudies data-id="element-81" />
        <About data-id="element-82" />
        <Contact data-id="element-83" />
      </main>
      <Footer data-id="element-84" />
    </div>;
}